<script lang="ts">
    
    import type { Section } from "../../Model/Section";
    import FormQuestion from "./FormQuestion.svelte";

    export let section: Section;

</script>

{#each section.questions as question}
    <FormQuestion {question} />
{/each}
